


















































import { Component, Vue } from "vue-property-decorator";
import { mapGetters, mapActions } from "vuex";

@Component({
    ...mapGetters(["account", "currentIcon"]),
    ...mapActions(["changeLink", "changeCurrentIcon", "initAccounBook"])
})
export default class NavAside extends Vue {
    isJzs = process.env.VUE_APP_TITLE === "jzs";
    skins: Skins.Skins[] = [
        { name: "default", color: "#fff", text: "默认--蓝白" },
        // { name: "dark", color: "#eeffff", text: "黑夜--高对比" },
        { name: "pink", color: "#df7576", text: "粉色--Pink" }
    ];
    icon = require(`../../../public/${process.env.VUE_APP_ICON}.png`);
    isLarge: boolean = false
    themeName: string | null = localStorage.getItem("theme");
    zoomValue = localStorage.zoomValue != null ? +(localStorage.zoomValue) : 1;
    jf = localStorage.getItem("jf") || "";
    disableTax(){
        let id = localStorage.getItem("isDisableTax")
        if(id) {
            if( +id === 0) return "[尊享版]"
            else if( +id === 1) return "[基础版]"
            else if( +id === 2) return "[试用版]"
            else if( +id === 3) return "[普通版]"
            else return ""
        }else return ""
    }
    mounted() {
        console.log(this.$store.state.account)
        let theme = localStorage.getItem("theme");
        if (theme === null) {
            this.clickSkin("default")
        } else {
            this.clickSkin(theme)
        }

        // this.clickEyePro();
        if (this.$store.state.navList().length > 0)
            this.$store.dispatch("changeLink", this.$store.state.navList()[1].message);

        document.body.onclick = () => {
            this.isLarge = false;
        }
    }

    /**
     * 点击头像后的操作
     */
    clickAvatar() {
        this.$router.push("/login");
        this.$store.dispatch("currentPosChange", 0);
    }

    getIconAsset(icon: string) {
        switch (icon) {
            case "客户": return "account";
            case "收费": return "charge";
            case "报税": return "tax";
            case "公司": return "manage";
            case "账套迁移": return "transfer";
            case "工商": return "gsnb";
            default: return icon;
        }
    }

    // 点击Icon跳转页面
    clickIconMenu(item: App.Menu) {
        if (item.icon !== "robot") {
            this.$store.dispatch("currentPosChange", 0);
            this.$router.push(item.message[0].url);
        } else {
            this.$utils.sendToElectron("open-robot");
        }
    }
    // 点击积分
    clickJf() {
        this.$router.push("/integral");
    }

    // 点击帮助
    clickHelp() {
        this.$utils.sendToElectron("openHelp");
    }
    // 切换皮肤
    showSkin: boolean = false;
    syncActive(): string {
        if (this.themeName === null) {
            return "default"
        } else return this.themeName;
    }
    clickSkin(theme: string) {
        this.themeName = theme;
        localStorage.setItem("theme", theme);

        document.body.classList.value = theme + (this.eyePro ? " green" : "");
    }
    // 监听缩放
    zoomChange(val: number) {
        // this.zoomValue = +val
        this.$store.dispatch("zoomChange", +val);
        localStorage.setItem("zoomValue", val.toString());
        this.$utils.sendToElectron("zoomChange", +val);
    }

    clickSlider(e: Event) {
        // e.preventDefault();
    }

    judgeName(str: string) {
        const length = str.length;
        const max = 8;
        return str.substring(length > max ? str.length - max : 0, length);
    }

    eyePro = localStorage.getItem("eye-protect") === null ? false : JSON.parse((<string>localStorage.getItem("eye-protect")));
    clickEyePro() {
        this.eyePro = !this.eyePro;
        localStorage.setItem("eye-protect", this.eyePro);
        document.body.classList.toggle("green");
        this.$message(`护眼模式已${this.eyePro ? "开启" : "关闭"}`);
    }
}
